import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  padding: 24px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
`;

const slugToLabel: Record<string, string> = {
  chyps: 'Symptoms Profile',
  neuroposture: 'Neuroposture',
  biomarker: 'Biomarker Profile',
  hemodynamics: 'Hemodynamics',
  fmri: 'fMRI',
  vng: 'VNG',
  'cervical-proprioception': 'Cervical Proprioception',
};

const ModalityPlaceholder: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const label = (slug && slugToLabel[slug]) || slug || 'Modality';

  return (
    <Container>
      <Title>{label}</Title>
      <p style={{ color: '#6b7280' }}>
        This modality module is under development. Content coming soon.
      </p>
    </Container>
  );
};

export default ModalityPlaceholder;
